export const EditorStyleContent = `
    /* Modern TinyMCE Header Styling */
    .tox .tox-menubar {
      background: linear-gradient(135deg, var(--marriott-primary, #00a4ba) 0%, var(--marriott-dark-blue, #31697a) 100%) !important;
      border-bottom: 1px solid rgba(0, 164, 186, 0.2) !important;
      border-radius: 12px 12px 0 0 !important;
      padding: 8px 12px !important;
    }
    
    .tox .tox-mbtn {
      color: #ffffff !important;
      border-radius: 6px !important;
      transition: all 0.2s ease !important;
      font-weight: 500 !important;
      padding: 6px 12px !important;
    }
    
    .tox .tox-mbtn:hover {
      background: rgba(255, 255, 255, 0.15) !important;
      transform: translateY(-1px) !important;
    }
    
    .tox .tox-mbtn--active {
      background: rgba(255, 255, 255, 0.2) !important;
    }
    
    /* Editor Header */
    .tox:not(.tox-tinymce-inline) .tox-editor-header {
      background: #ffffff !important;
      border-bottom: 1px solid rgba(0, 164, 186, 0.15) !important;
      border-radius: 12px 12px 0 0 !important;
      box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.06) !important;
    }
    
    /* Primary Toolbar */
    .tox .tox-toolbar-overlord > .tox-toolbar__primary {
      background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%) !important;
      border-bottom: 1px solid rgba(0, 164, 186, 0.1) !important;
      padding: 8px 12px !important;
    }
    
    /* Toolbar Buttons */
    .tox .tox-tbtn {
      border-radius: 6px !important;
      transition: all 0.2s ease !important;
      margin: 2px !important;
    }
    
    .tox .tox-tbtn:hover {
      background: rgba(0, 164, 186, 0.1) !important;
      transform: translateY(-1px) !important;
      box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.1) !important;
    }
    
    .tox .tox-tbtn--enabled {
      background: var(--marriott-primary, #00a4ba) !important;
      color: white !important;
    }
    
    .tox .tox-tbtn--enabled:hover {
      background: var(--marriott-dark-blue, #31697a) !important;
    }
    
    /* Split Buttons */
    .tox .tox-split-button:hover {
      box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.1) !important;
    }
    
    /* Dropdown Menus */
    .tox .tox-menu {
      border-radius: 8px !important;
      border: 1px solid rgba(0, 164, 186, 0.2) !important;
      box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1) !important;
    }
    
    .tox .tox-collection__item {
      border-radius: 4px !important;
      margin: 2px 4px !important;
    }
    
    .tox .tox-collection__item:hover {
      background: rgba(0, 164, 186, 0.08) !important;
    }
    
    .tox .tox-collection__item--active {
      background: var(--marriott-primary, #00a4ba) !important;
      color: white !important;
    }
    
    /* Status Bar */
    .tox .tox-statusbar {
      background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%) !important;
      border-top: 1px solid rgba(0, 164, 186, 0.15) !important;
      border-radius: 0 0 12px 12px !important;
      padding: 8px 12px !important;
    }
    
    /* Content Area */
    .tox .tox-edit-area__iframe {
      border: none !important;
      background: #ffffff !important;
    }
    
    /* Notifications */
    .tox .tox-notification {
      border-radius: 8px !important;
      border: 1px solid rgba(0, 164, 186, 0.2) !important;
      box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1) !important;
    }
    
    /* Dialog/Modal styling */
    .tox .tox-dialog {
      border-radius: 12px !important;
      border: 1px solid rgba(0, 164, 186, 0.2) !important;
      box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1) !important;
    }
    
    .tox .tox-dialog__header {
      background: linear-gradient(135deg, var(--marriott-primary, #00a4ba) 0%, var(--marriott-dark-blue, #31697a) 100%) !important;
      border-radius: 12px 12px 0 0 !important;
      color: white !important;
    }
    
    .tox .tox-dialog__footer {
      background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%) !important;
      border-radius: 0 0 12px 12px !important;
      border-top: 1px solid rgba(0, 164, 186, 0.15) !important;
    }
    
    /* Comment Annotation Styles - Temporarily Disabled */
    /*
    .comment-annotation {
      background: rgba(255, 235, 59, 0.3) !important;
      border-bottom: 2px solid #ffc107 !important;
      cursor: pointer !important;
      transition: all 0.3s ease !important;
      padding: 1px 3px !important;
      border-radius: 3px !important;
      position: relative !important;
      box-shadow: 0 1px 2px rgba(255, 193, 7, 0.2) !important;
    }
    
    .comment-annotation:hover {
      background: rgba(255, 235, 59, 0.6) !important;
      border-bottom-color: #ff9800 !important;
      transform: translateY(-1px) !important;
      box-shadow: 0 2px 4px rgba(255, 152, 0, 0.3) !important;
    }
    
    .comment-annotation.active {
      background: rgba(0, 164, 186, 0.25) !important;
      border-bottom-color: var(--marriott-primary, #00a4ba) !important;
      box-shadow: 0 2px 6px rgba(0, 164, 186, 0.3) !important;
    }
    
    .comment-annotation::after {
      content: '💬' !important;
      position: absolute !important;
      top: -10px !important;
      right: -3px !important;
      font-size: 11px !important;
      opacity: 0.8 !important;
      pointer-events: none !important;
      filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.1)) !important;
    }
    
    .comment-annotation.newly-created {
      animation: commentPulse 1.5s ease-in-out !important;
    }
    
    @keyframes commentPulse {
      0% { 
        background: rgba(0, 164, 186, 0.8) !important; 
        transform: scale(1.05) !important;
      }
      50% { 
        background: rgba(255, 235, 59, 0.6) !important; 
      }
      100% { 
        background: rgba(255, 235, 59, 0.3) !important; 
        transform: scale(1) !important;
      }
    }
    */
  `;

export const VariantBodyEditorStyleContent = `
    /* Modern TinyMCE Header Styling - Variant Body Specific (No Top Border Radius) */
    .tox .tox-menubar {
      background: linear-gradient(135deg, var(--marriott-primary, #00a4ba) 0%, var(--marriott-dark-blue, #31697a) 100%) !important;
      border-bottom: 1px solid rgba(0, 164, 186, 0.2) !important;
      border-radius: 0 !important;
      padding: 8px 12px !important;
    }
    
    /* Override global container styles to remove top border radius */
    .tox-tinymce {
      border-radius: 0 0 12px 12px !important;
    }
    
    .tox-editor-container {
      border-radius: 0 0 12px 12px !important;
    }
    
    .tox .tox-mbtn {
      color: #ffffff !important;
      border-radius: 6px !important;
      transition: all 0.2s ease !important;
      font-weight: 500 !important;
      padding: 6px 12px !important;
    }
    
    .tox .tox-mbtn:hover {
      background: rgba(255, 255, 255, 0.15) !important;
      transform: translateY(-1px) !important;
    }
    
    .tox .tox-mbtn--active {
      background: rgba(255, 255, 255, 0.2) !important;
    }
    
    /* Editor Header - No Top Border Radius */
    .tox:not(.tox-tinymce-inline) .tox-editor-header {
      background: #ffffff !important;
      border-bottom: 1px solid rgba(0, 164, 186, 0.15) !important;
      border-radius: 0 !important;
      box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.06) !important;
    }
    
    /* Primary Toolbar */
    .tox .tox-toolbar-overlord > .tox-toolbar__primary {
      background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%) !important;
      border-bottom: 1px solid rgba(0, 164, 186, 0.1) !important;
      padding: 8px 12px !important;
    }
    
    /* Toolbar Buttons */
    .tox .tox-tbtn {
      border-radius: 6px !important;
      transition: all 0.2s ease !important;
      margin: 2px !important;
    }
    
    .tox .tox-tbtn:hover {
      background: rgba(0, 164, 186, 0.1) !important;
      transform: translateY(-1px) !important;
      box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.1) !important;
    }
    
    .tox .tox-tbtn--enabled {
      background: var(--marriott-primary, #00a4ba) !important;
      color: white !important;
    }
    
    .tox .tox-tbtn--enabled:hover {
      background: var(--marriott-dark-blue, #31697a) !important;
    }
    
    /* Split Buttons */
    .tox .tox-split-button:hover {
      box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.1) !important;
    }
    
    /* Dropdown Menus */
    .tox .tox-menu {
      border-radius: 8px !important;
      border: 1px solid rgba(0, 164, 186, 0.2) !important;
      box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1) !important;
    }
    
    .tox .tox-collection__item {
      border-radius: 4px !important;
      margin: 2px 4px !important;
    }
    
    .tox .tox-collection__item:hover {
      background: rgba(0, 164, 186, 0.08) !important;
    }
    
    .tox .tox-collection__item--active {
      background: var(--marriott-primary, #00a4ba) !important;
      color: white !important;
    }
    
    /* Status Bar */
    .tox .tox-statusbar {
      background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%) !important;
      border-top: 1px solid rgba(0, 164, 186, 0.15) !important;
      border-radius: 0 0 12px 12px !important;
      padding: 8px 12px !important;
    }
    
    /* Content Area */
    .tox .tox-edit-area__iframe {
      border: none !important;
      background: #ffffff !important;
    }
    
    /* Notifications */
    .tox .tox-notification {
      border-radius: 8px !important;
      border: 1px solid rgba(0, 164, 186, 0.2) !important;
      box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1) !important;
    }
    
    /* Dialog/Modal styling */
    .tox .tox-dialog {
      border-radius: 12px !important;
      border: 1px solid rgba(0, 164, 186, 0.2) !important;
      box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1) !important;
    }
    
    .tox .tox-dialog__header {
      background: linear-gradient(135deg, var(--marriott-primary, #00a4ba) 0%, var(--marriott-dark-blue, #31697a) 100%) !important;
      border-radius: 12px 12px 0 0 !important;
      color: white !important;
    }
    
    .tox .tox-dialog__footer {
      background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%) !important;
      border-radius: 0 0 12px 12px !important;
      border-top: 1px solid rgba(0, 164, 186, 0.15) !important;
    }
    
    /* Comment Annotation Styles - Temporarily Disabled */
    /*
    .comment-annotation {
      background: rgba(255, 235, 59, 0.3) !important;
      border-bottom: 2px solid #ffc107 !important;
      cursor: pointer !important;
      transition: all 0.2s ease !important;
      padding: 1px 2px !important;
      border-radius: 2px !important;
      position: relative !important;
    }
    
    .comment-annotation:hover {
      background: rgba(255, 235, 59, 0.5) !important;
      border-bottom-color: #ff9800 !important;
    }
    
    .comment-annotation.active {
      background: rgba(0, 164, 186, 0.2) !important;
      border-bottom-color: var(--marriott-primary, #00a4ba) !important;
    }
    
    .comment-annotation::after {
      content: '💬' !important;
      position: absolute !important;
      top: -8px !important;
      right: -2px !important;
      font-size: 10px !important;
      opacity: 0.7 !important;
      pointer-events: none !important;
    }
    */
`;
